<pbc-sorter [config]="OffeneGutachtenSorterConfig" [sorter]="offeneGutachten.sorter$ | async" (sorterChange)="offeneGutachten.sorter$.next($event)"></pbc-sorter>
